
import React from 'react';
import * as api from '../../../../../api';
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import 'font-awesome/css/font-awesome.min.css'
import * as moment from "moment";
import { translateSiteName } from "../../../../../helpers/data-helpers"
import { Icon,Divider, Button } from 'semantic-ui-react'
import { Subject, merge} from "rxjs";
import {BasicFilter} from "../../../../../components/table/filters/basic-filter";

class UserSitesTab extends React.Component {

  constructor(props) {
    super(props);

    this.localRefreshTrigger = new Subject();
    this.onRefreshTrigger = this.generateRefreshTrigger();

    this.state = {
      sitesList: [],
      selected: [],
      totalCount: this.props.data ? this.props.data.length : 0,
            
      isLoading: false,
      pageSettings: {
          pageNo: this.props.startingPage || 1,
          pageSize: this.props.startingLimit || 10
      },
      filterSettings: {
          filter: "",
          fromDate: null,
          toDate: null
      }
    };
    this.fetchData();
    this.onChange = this.onChange.bind(this);
  }

  resyncJLLPAMsites = () => {
    this.setState({ isLoading: true });
    const query = this.generateQueryFromState(); // Assuming it includes necessary params for resync

    api.resyncJLLPAMSites(this.props.id)
    .then(data => {
     
   
  
    api.getSitesList(this.props.customerId, query)
      .then(data => {
        this.setState({ sitesList: data.data, isLoading: false });
        this.fetchData(); // Refresh the entire component data after resync
      })
      .catch(error => {
        console.log(error);
        this.setState({ isLoading: false });
      });

    })
    .catch(error => {
      console.log(error);
      this.setState({ isLoading: false });
    });
  }

  
  fetchData() {


    const query = this.generateQueryFromState();


    api.getSitesList(this.props.customerId, query)
      .then(data => {
        this.setState({ sitesList: data.data });
        this.setState({isLoading: false});
      }).catch(function (error) {
        // Acquire token interactive failure
        console.log(error);
      });

    api.getUserSites(this.props.id)
      .then(data => {
        this.setState({ selected: data.map((item) => { return item.siteKey.toString() }) });
        this.setState({isLoading: false});
      }).catch(function (error) {
        // Acquire token interactive failure
        console.log(error);
      });
  }

  requestRefresh = () => {

    this.setState({isLoading: true});
    this.fetchData();
    this.localRefreshTrigger.next();

   
};

  generateRefreshTrigger() {
    const dependents = [this.localRefreshTrigger];
    if (this.props.refreshDataTrigger) {
        dependents.push(this.props.refreshDataTrigger);
    }
    return merge(...dependents);
}

  onFilterChange = (filterSettings) => {
      

    if(this.props.storeName !== "")
    {
        localStorage.setItem(this.props.storeName, filterSettings.filter)
    }
    this.setState({pageSettings: {
        pageNo: 1,
        pageSize: this.state.pageSettings.pageSize
    }})

    this.setState({filterSettings}, this.requestRefresh);
};

generateQueryFromState() {
  const queryStringParams = [];

  const extractSettings = (settings) => {
      for(const param in settings)
      {
          const setting = settings[param];
          if(typeof(setting) === "undefined" || !setting || (typeof(setting) === "string" && setting.length === 0))
          { continue; }

          const value = (setting instanceof Date) ? moment(setting).format("YYYY/MM/DD") : setting;
          queryStringParams.push(`${encodeURIComponent(param)}=${encodeURIComponent(value)}`);
      }
  }

  extractSettings(this.state.sortSettings || {});
  extractSettings(this.state.filterSettings || {});

  return queryStringParams.join("&");
}

  onChange(selected, selection) {
  
    if (selected.length > 0 && selection.length > 0) {
      for (let item of selection) {
        if (selected.includes(item)) {

          
          api.addUserSites(this.props.id, item)
            .then((data) => {
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    }

    if (selected.length >= 0 && selection.length > 0) {
      for (let item of selection) {
        if (!selected.includes(item)) {
          api.removeUserSites(this.props.id, item)
            .then((data) => {
            })
            .catch((error) => {
              console.log(error)
            })
        }
      }
    }

    if (selected.length > 0 && selection.length === 0) {
      for (let item of selected) {
        api.addUserSites(this.props.id, item)
          .then((data) => {
          })
          .catch((error) => {
            console.log(error)
          })
      }
    }


    this.setState({ selected });
  }

  render() {
    const options = this.state.sitesList.map((item) => { return { value: item.siteKey, label: translateSiteName(item) } })
    const { selected } = this.state;
    const Filter = this.props.filterComponent || BasicFilter;

    return (
      <div>
              {this.props.customerId === "15592" && (
        <Button
          onClick={this.resyncJLLPAMsites}
          color="blue"
          floated="right"
          icon="sync"
          content="Resync from ICMAS PAM"
          disabled={this.state.isLoading}
        />
      )}
                        <React.Fragment>
                    <Filter
                        filter={this.state.filterSettings.filter}
                        totalCount={this.state.totalCount}
                        onSubmitFilter={this.onFilterChange}
                        disabled={this.state.isLoading}
                        fromDate={this.state.filterSettings.fromDate}
                        toDate={this.state.filterSettings.toDate}
                    />
                    <Divider/>
                </React.Fragment>
        <div className="list-sites-flex">
          <div className="list-sites"> List of Available Sites </div>
          <div className="list-sites mr-sites"> User’s Sites </div>
        </div>
        <DualListBox
          options={options}
          selected={selected}
          onChange={this.onChange}
          className="edit-user-btn"
          icons={{
            moveLeft: <Icon className="long arrow alternate left" ></Icon>,
            moveRight: <Icon className="long arrow alternate right" ></Icon>,
            // moveAllRight: <span>Add All</span>,
          }}
        />
      </div>
    );
  }

}
export default UserSitesTab